import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { propShape } from '../../../../helpers/custom-prop-types';
import InputError from '../../Common/InputError';
import PlainInput from '../../Common/PlainInput';
import PlainSelect from '../../Common/PlainSelect';
const OrganizationFieldsAndLabel = (props) => {
    const { organization: { input: organizationInput }, organizationCandidate: { input: candidateInput }, organizationId: { input: organizationIdInput, meta: organizationIdMeta }, otherOrganization: { input: organizationOtherInput, meta: organizationOtherMeta, }, } = props;
    const isOther = organizationIdInput.value.toString() === '0';
    const options = useMemo(() => [
        { label: '選択してください', value: '' },
        ...(candidateInput.value || []).map((row) => ({
            label: row.name,
            value: row.id,
        })),
        { label: 'その他', value: 0 },
    ], [candidateInput.value]);
    const wrapOnChange = useCallback((e) => {
        const { value } = e.currentTarget;
        const organization = candidateInput.value.find((v) => v.id.toString() === value.toString());
        if (organization) {
            organizationInput.onChange(organization);
        }
        else {
            organizationInput.onChange(null);
        }
    }, [organizationInput, candidateInput.value]);
    const metas = useMemo(() => [organizationIdMeta, organizationOtherMeta], [organizationIdMeta, organizationOtherMeta]);
    if (candidateInput.value.length === 0) {
        return (_jsxs("div", Object.assign({ className: 'form form-solution' }, { children: [_jsx("h3", { children: "\u4F01\u696D\u540D" }), _jsx("input", { className: 'input-form-text', disabled: true, placeholder: '', value: organizationInput.value.name })] })));
    }
    return (_jsxs("div", Object.assign({ className: 'form form-solution req' }, { children: [_jsx("h3", { children: "\u4F01\u696D\u540D" }), _jsxs("div", Object.assign({ style: { height: 42 } }, { children: [_jsx("div", Object.assign({ className: 'input-form-select is-half' }, { children: _jsx(PlainSelect, { className: 'form-solution-select', input: organizationIdInput, meta: organizationIdMeta, options: options, wrapOnChange: wrapOnChange }) })), _jsx(PlainInput, { className: 'input-form-text is-half asign-state', disabled: !isOther, input: organizationOtherInput, meta: organizationOtherMeta, placeholder: '' })] })), _jsx(InputError, { metas: metas })] })));
};
OrganizationFieldsAndLabel.propTypes = {
    organization: propShape().isRequired,
    organizationCandidate: propShape().isRequired,
    organizationId: propShape().isRequired,
    otherOrganization: propShape().isRequired,
};
export default OrganizationFieldsAndLabel;
